"use client";

import * as React from "react";
import * as SwitchPrimitive from "@radix-ui/react-switch";

import { cn } from "./utils";

function Switch({
  className,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        "peer inline-flex h-[1.15rem] w-8 shrink-0 items-center rounded-full border transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed",
        className,
      )}
      style={{
        backgroundColor: props.checked ? 'var(--color-primary)' : 'rgb(156 163 175)',
        borderColor: 'transparent',
        opacity: props.disabled ? '0.6' : '1'
      }}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          "pointer-events-none block size-4 rounded-full ring-0 transition-transform data-[state=checked]:translate-x-[calc(100%-2px)] data-[state=unchecked]:translate-x-0",
        )}
        style={{
          backgroundColor: 'var(--color-background)'
        }}
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
